import React from 'react'
import { useState, useEffect, useRef } from 'react';
import { configData } from "../config";
import DatePicker from 'react-datepicker';
import { format } from "date-fns";
import { Autocomplete, TextField, CircularProgress, Button, Box  } from '@mui/material';
import SweetAlert from "react-sweetalert2";
import Swal from 'sweetalert2';
import moment from 'moment-timezone';
import Popper from '@mui/material/Popper';
import Select from 'react-dropdown-select';
import Loading from './Loading';
import ApplicantAdminEditProfile from './ApplicantAdminEditProfile';
import ApplicantSAAdminEditProfile from './ApplicantSAAdminEditProfile';
import { Link, useNavigate,useLocation  } from 'react-router-dom';

moment.tz.setDefault('America/Los_Angeles');


const ViewApplicationProfile = ({uid,username,userLoggedinDetails,userLoggedInRoles,userRoles}) => {
    const[coursesList, setCoursesList] = useState({});
    const[profilesummary, setprofilesummarylist] = useState({});
    const[keyinfo, setkeyinfolist] = useState({});
    const[contactinfo, setcontactinfolist] = useState({});
    const[systeminfo, setsysteminfolist] = useState({});
    const[educationinfo, seteducationinfolist] = useState({});
    const[socialinfo, setsocialinfolist] = useState({});
    const[careerinfo, setcareerinfolist] = useState({});
    const[userinfo, setuserinfolist] = useState({});
    const[appliedcoursesList, setAppliedCoursesList] = useState({});
    const[userSortflags, setUserSortflags] = useState({});
    const[sortflagList, setSortflagList] = useState([]);
    const[sortflagValue, setSortflagValue] = useState("");
    const[appProfTotal, setAppProfTotal] = useState("");
    const[applicationID, setApplicationID] = useState("");
    const[applicationStatus, setApplicationStatus] = useState("");
    const[appRegStep, setAppRegStep] = useState("");
    const[appUserDetail, setAppUserDetail] = useState({});
    const[applicationPicture, setApplicationPicture] = useState("");
    const[appSalespersonLink, setAppSalespersonLink] = useState("");
    const[applicationRecentApp, setApplicationRecentApp] = useState("");
    const[appMiscInfo, setAppMiscInfo] = useState({});
    const[userDocTalkAsset, setUserDocTalkAsset] = useState({});
    const[userLeadAsset, setUserLeadAsset] = useState({});
    const[userEventAsset, setUserEventAsset] = useState({});

    const [openDOC, setOpenDOC] = useState(false);
    const [docTalks, setDocTalks] = useState([]);
    const [search, setSearch] = useState("");

    const[salespersonList, setSalespersonList] = useState({});
    const[sameapplist, setSameappList] = useState({});

    const [activeModal, setActiveModal] = useState(null);
    
    const[selectedSalesperson, setselectedSalesperson] = useState('');
    const[selectedPriority, setselectedPriority] = useState('');
   // const[showEventModal, setShowEventModal] = useState(false);
   //  const[showEventViewModal, setShowEventViewModal] = useState(false);
    // const[showTaskModal, setShowTaskModal] = useState(false);
   //  const[showViewTaskModal, setShowViewTaskModal] = useState(false);
     const [isLoading, setIsLoading] = useState(true);
    const[success,setSuccess] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
      const [loading, setLoading] = useState(false);
       const [open, setOpen] = useState(true);
      var currentdate = new Date().toLocaleDateString();
      const loggedin_uid = localStorage.getItem('uid');
      const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
      const currentDatePST = moment().tz('America/Los_Angeles').format('MM-DD-YYYY');
       const currentDateTimePST = moment().tz('America/Los_Angeles').format('MM/DD/YYYY h:mm:ss A');
       const defaultDueDateObj = moment()
        .tz('America/Los_Angeles')
        .set({ hour: 1, minute: 0, second: 0, millisecond: 0 })
        .toDate();
       const currentDateCustomTimePST = format(defaultDueDateObj, "MM-dd-yyyy h:mm:ss aa");
    var currenttime = new Date().toLocaleTimeString();
    var currentdatetime = currentdate+' '+currenttime;
    
     const [eventformData, setEventFormData] = useState({
        loggedin_uid: localStorage.getItem('drupal_uid'),
        drupal_uid: uid,
        subject: 'Out Bound Call',
        details: ''
    });
   
    const [taskformData, setTaskFormData] = useState({
        loggedin_uid: localStorage.getItem('drupal_uid'),
        drupal_uid: uid,
        salesperson: localStorage.getItem('drupal_uid'),
        due_date: currentDateCustomTimePST,
        due_date_obj: defaultDueDateObj,
        priority: 'Medium',
        repeat: '',
        frequency: '',
        spantype: 'Day',
        subject: '',
        details: '',
        apply_courses: '',
    });
     const [viewtaskformData, setViewTaskFormData] = useState({
        loggedin_uid: localStorage.getItem('drupal_uid'),
        drupal_uid: uid,
        id:'',
        salesperson: '',
        due_date: '',
        priority: 'Medium',
        repeat: '',
        frequency: '',
        spantype: 'Day',
        subject: '',
        details: '',
        apply_courses: '',
    });
     const [eventlist, setEventList] = useState({});
     const [eventdetailedview, setEventDetailedView] = useState({});
     const [taskdetailedview, setTaskDetailedView] = useState({});
     const [tasklist, setTaskList] = useState({});
    
     
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    const navigate = useNavigate();
    
    // const handleModalOpen = (modalname) => {
    //     if(modalname == 'add_event_log') {
    //         setShowEventModal(true);
    //     }
    //     if(modalname == 'view_event_log') {
    //         setShowEventViewModal(true);
    //     }
    //     if(modalname == 'add_task') {
    //     setShowTaskModal(true);
    //     }
        
    // };

    const [toggles, setToggles] = useState({
      appliedCourses: true,
      profileSummary: false,
      keyAppInfo: true,
      sameAppToggle: false,
      AppSysData: false,
      educationToggle: false,
      socialMediaToggle: false,
      careerToggle: false,
      accountAdminToggle: false,
      miscellaneousToggle: false,
      eventLog: true,
      scheduleTask: true,
      sortFlags: false,
      contactInfo: false,
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleModalOpen = (modalname) => {
  setActiveModal(null);
    setTimeout(() => {
    setActiveModal(modalname); //  open again
  }, 10);
};
    const handleViewModalOpen = async (modalname,eventid) => {
     setActiveModal(null);
        // if(modalname == 'add_event_log') {
        //     setShowEventModal(true);
        // }
          setTimeout(async () => {
    setActiveModal(modalname);
        if(modalname == 'view_event_log') {
           // setShowEventViewModal(true);
          
            if(uid && !Number.isNaN(uid)) {
        
                try {
                const response =  await fetch(
                app_url+'smwweventlog/getusereventdetailedview?uid='+uid+'&eventid='+eventid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") {
                    
                    setEventDetailedView(responsedata.data.result);
                    
                } 
                } catch (err) {
                }
            }
        

        }
        if(modalname == 'view_task') {
       // setShowViewTaskModal(true);
        if(uid && !Number.isNaN(uid)) {
        
                try {
                const response =  await fetch(
                app_url+'smwwtask/getusertaskdetailedview?uid='+uid+'&taskid='+eventid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") {
                    
                    setTaskDetailedView(responsedata.data.result);
                    setViewTaskFormData({ 
                      loggedin_uid: userLoggedinDetails.drupal_uid,
                      drupal_uid: uid,
                      id:responsedata.data.result.id,
                      salesperson: responsedata.data.result.field_assignee,
                      due_date: responsedata.data.result.field_due_date,
                      priority: responsedata.data.result.field_priority,
                      repeat: responsedata.data.result.field_repeat,
                      frequency: responsedata.data.result.field_frequency,
                      spantype: responsedata.data.result.field_frequency_type,
                      subject: responsedata.data.result.title,
                      details: responsedata.data.result.body,
                      apply_courses: responsedata.data.result.field_apply_courses,
                    });
                    
                } 
                } catch (err) {
                }
            }
        }
          }, 10);
    };
 
const handleModalClose = () => {
  setActiveModal(null);

  // cleanup
  setEventDetailedView({});
  setTaskDetailedView({});
};

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setEventFormData({ ...eventformData, [name]: value });
    };
    const handleTaskChange = (e) => {
        const { name, value } = e.target;
       
        setTaskFormData({ ...taskformData, [name]: value });
        console.log(taskformData);
    };
    const handleViewTaskChange = (e) => {
        const { name, value } = e.target;
       if(name == "salesperson") {
          setselectedSalesperson(value);
       }
       if(name == "priority") {
          setselectedPriority(value);
       }
       
        setViewTaskFormData({ ...viewtaskformData, [name]: value });
        console.log(taskformData);
    };
    const handleDateChange = (date) => {
   
    if (date) {
     const formattedDate = format(date, "MM-dd-yyyy h:mm:ss aa");
       setTaskFormData({ ...taskformData, ['due_date']: formattedDate, ['due_date_obj']: date });
      
      // You can now use formattedDate for your application logic
    }
  };
  const handleViewTaskDateChange = (date) => {
   
    if (date) {
      const formattedDate = format(date, "yyyy-MM-dd HH:mm:ss"); // Example: 2025-06-21 11:03:00
       setViewTaskFormData({ ...viewtaskformData, ['due_date']: formattedDate });
      
      // You can now use formattedDate for your application logic
    }
  };
  const handleInputChange = (event, newInputValue) => {
   
     setInputValue(newInputValue)
    // Handle the new input value as needed
  };
//   const isPastDateTimeInPST = (dateTimeToCheck) => {
//   // Get current datetime in PST
//   const currentPST = moment.tz("America/Los_Angeles");
  
//   // Parse and keep the datetime to check in PST for comparison
//   const dateTimeToCheckPST = moment.tz(dateTimeToCheck, "America/Los_Angeles");
  
//   return dateTimeToCheckPST.isBefore(currentPST);
// };
  const isPastDateTimeInPST = (dateTimeToCheck) => {
    // Get current datetime in PST
    const format = "M/D/YYYY";
    const currentPST = moment.tz("America/Los_Angeles").startOf('day'); 
    
    // Parse and keep the datetime to check in PST for comparison
    const dateTimeToCheckPST = moment.tz(dateTimeToCheck, format, "America/Los_Angeles").startOf('day');
    
    return dateTimeToCheckPST.isBefore(currentPST);
  };

    useEffect(() => {
      Promise.all([
        getcourselist(),
        retrieveSortFlags(),
        geteventlist(),
        gettasklist(),
        getsalespersonlist(),
        getsameapplist(),
        getapplicationdetails(),
        getDocTalkList()
      ])
      .then(() => {
        setIsLoading(false);
      })
    },[]);
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (inputValue.trim() === '') { // Only search if input is long enough
        setOptions([]);
        return;
      }

      setLoading(true);
      try {
          const response = await fetch(app_url+'viewprofile/getalluserlist?query='+inputValue);
        const data = await response.json();
        setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setOptions([]); // Clear options on error
      } finally {
        setLoading(false);
      }
    };

    const debounceTimeout = setTimeout(() => {
      fetchSuggestions();
    }, 500); // Debounce API calls

    return () => clearTimeout(debounceTimeout);
  }, [inputValue]);
  const renderOption = (props, option) => (
    <li {...props}>
     
        {option.label}
      
    </li> 
  );
  
  const getOptionLabel = (option) => option.label;
  
    async function getcourselist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'viewprofile/getajaxcourselist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCoursesList(responsedata.data.result);
                setAppliedCoursesList(responsedata.data.applied_courses);
            } 
        } catch (err) {
            
         }
        }
  }

  async function  retrieveSortFlags() {
    
    if(uid && !Number.isNaN(uid)) {
    const response = await fetch(
      app_url+'sortflag/getnewsortflaglist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setSortflagList(responsedata.data.result);
    }
  }
  }

   async function getsalespersonlist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'viewprofile/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        }
  }
   async function getsameapplist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'viewprofile/getsameapplist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSameappList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        }
  }
  async function geteventlist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwweventlog/getusereventlist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setEventList(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }
     async function gettasklist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwwtask/getusertasklist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setTaskList(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }
   async function getusersortflags() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'viewprofile/getusersortflaglist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                 setUserSortflags(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }
 async function getapplicationdetails() { 
    
    if(uid!='' || username!='') {
      try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'viewprofile/getapplicationprofiledetails?uid='+uid+'&username='+username,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
      //uid = responsedata.data.user.drupal_uid;
      setprofilesummarylist(responsedata.data.profilesummary);
      setkeyinfolist(responsedata.data.keyinfo);
      setcontactinfolist(responsedata.data.contactinfo);
      setsysteminfolist(responsedata.data.systeminfo);
      seteducationinfolist(responsedata.data.educationinfo);
      setsocialinfolist(responsedata.data.socialinfo);
      setcareerinfolist(responsedata.data.careerinfo);
      setuserinfolist(responsedata.data.userinfo);
      setUserSortflags(responsedata.data.user_sort_flags);
      setAppProfTotal(responsedata.data.totalpurchase);
      setApplicationID(responsedata.data.appid);
      setApplicationStatus(responsedata.data.appstatus);
      setAppRegStep(responsedata.data.appregstep);
      setAppUserDetail(responsedata.data.user);
      setApplicationPicture(responsedata.data.picture);
      setAppSalespersonLink(responsedata.data.salespersonlink);
      setApplicationRecentApp(responsedata.data.recent_app);
      setAppMiscInfo(responsedata.data.miscinfo);
      setUserDocTalkAsset(responsedata.data.user_doctalk_assets);
      setUserLeadAsset(responsedata.data.user_lead_assets);
      setUserEventAsset(responsedata.data.user_event_attendee_assets);
    }
    }  catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  }
  }


const [selectedCourse, setSelectedCourse] = useState(null);
const [inputCourseValue, setInputCourseValue] = useState("");

    function CustomPopper(props) {
        const { anchorEl, style, ...other } = props;

        return (
            <Popper
                anchorEl={anchorEl}
                placement="bottom"
                modifiers={[
                    {
                    name: "computeStyles",
                    options: { adaptive: false }
                    },
                    {
                    name: "sameWidth",
                    enabled: true,
                    phase: "beforeWrite",
                    requires: ["computeStyles"],
                    fn: ({ state }) => {
                        state.styles.popper.width = `${anchorEl?.offsetWidth}px`;  // match input width
                    }
                    }
                ]}
                style={{
                    ...style,
                    zIndex: "0"
                }}
                {...other}
            />
        );
    }
   
    const handleAddCourse = async (value) => {
        const postData = {
            uid:uid,
            course_code:value
        };
        try {
            const response = await fetch(app_url + 'viewprofile/addcourse', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              //  alert('Added Successfully');
               
               setAppliedCoursesList(data.data.applied_courses);
               geteventlist();
            }
            else if(data.data.msg === "Error") {
               alert(data.data.result);
               
            }
        } catch (err) {
            
        }
    };
    const handleDeleteCourse = async (value) => {
        const postData = {
            uid:uid,
            course_code:value
        };
        try {
            const response = await fetch(app_url + 'viewprofile/deletecourse', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              //  alert('Deleted Successfully');
               setAppliedCoursesList(data.data.applied_courses);
               geteventlist();
            }
        } catch (err) {
            
        }
    };
    const handleDeleteSortflag = async (value) => {
        const postData = {
            uid:uid,
            tid:value
        };
        try {
            const response = await fetch(app_url + 'viewprofile/deletesortflag', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               alert('Deleted Successfully');
               setUserSortflags(data.data.sort_flags);
               geteventlist();
            }
        } catch (err) {
            
        }
    };
  const handleOpen = () => {
    setSortflagValue();
  };

  const handleSortflagSubmit = async event => {
    event.preventDefault();
    
      const postData = {
        tid:sortflagValue,
        uid:uid
      };
      const response = await fetch(app_url + 'sortflag/addsortflag', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
          alert('Added Successfully');
          window.location.reload();
        } else {
            alert(data.data.text);
        }
       
    
  };  

    const handleSameAppChange = async (event, newValue) => {
      if (!newValue) return;
      if(newValue.id == uid) {
       alert("This is the same user you are viewing - please add a different one.");
       setInputValue('');
       return false;

      }
     const postData = {
            uid:newValue.id,
            match_uid:uid,
            current_user:localStorage.getItem('drupal_uid')
        };
        try {
            const response = await fetch(app_url + 'viewprofile/addsameapp', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              alert('Added Successfully');
              //window.location.reload();
              setSameappList(data.data.result);
              geteventlist();
              setInputValue(''); 
            }
            if(data.data.msg === "Error") {
              alert(data.data.text);
            }
        } catch (err) {
            
        }
};
 const handleDeleteSameApp = async (id,match_uid,uid) => {
        const postData = {
            id:id,
            uid:uid,
            match_uid:match_uid,
            current_user:localStorage.getItem('drupal_uid')
        };
        try {
            const response = await fetch(app_url + 'viewprofile/deletesameapp', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               alert('Deleted Successfully');
               getsameapplist();
              //setSameappList(data.data.result);
               geteventlist();
            }
        } catch (err) {
            
        }
    };

  const domainName = window.location.host.replace(/^https?:\/\//, '');
  const agencyDomains = [
    configData.RSMWW_AGENCY_DOMAIN,
    configData.RSMWW_AGENCY_DOMAIN1
  ];
  const scoutDomains = [
    configData.RSMWW_SCOUT_DOMAIN,
    configData.RSMWW_SCOUT_DOMAIN1,
    configData.RSMWW_SCOUT_DOMAIN2
  ];

  const [activeView, setActiveView] = useState("view");
  // const showView = () => {
  //   if (activeView !== "view") {
  //     setActiveView("view");
  //   } else {setActiveView("edit"); navigate(`/user/${uid}/${edit}`);}
  // };

  const showView = () => {
    const newView = activeView === "view" ? "edit" : "view";
    setActiveView(newView);

    navigate(`/user/${uid}/${newView}`);
  };

const location = useLocation();

useEffect(() => {
  if (location.pathname.includes("/edit")) {
    setActiveView("edit");
  } else {
    setActiveView("view");
  }
}, [location.pathname]);


const successAppEditMessage = location.state?.result; 
  
const [successEditMessage, setSuccessEditMessage] = useState('');

        useEffect(() => {
          if (successAppEditMessage) {
            gettasklist();
            getcourselist();
            setSuccessEditMessage(successAppEditMessage);
            getapplicationdetails();
            window.history.replaceState({}, '');
          }
        }, [successEditMessage, location.state]);

  const handleImpersonate = async (uid) => {
    if(uid && !Number.isNaN(uid)) {
      try {
        setIsLoading(true);
        const response =  await fetch(
        app_url+'site/impersonateuser?uid='+uid,
        {
          method: "GET",

          headers: {
            'Content-Type': 'application/json',
          },
        }
        )
        const responsedata =  await response.json();
              
        if(responsedata.data.msg == "Success") {
          window.location.reload();
          } 
        } catch (err) {
          }finally {
          setIsLoading(false);
        }
    }
      
  };

  const handleAgentInvite = async () => {
      const postData = {
        uid:uid
      };
      const response = await fetch(app_url + 'smwwagency/agentinvite', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
          //setSuccess(data.data.result);
          localStorage.setItem("invitesuccessMessage", data.data.result);
          window.location.href = "/user/"+uid;
        }
  };
  const handleScoutInvite = async () => {
      const postData = {
        uid:uid
      };
      const response = await fetch(app_url + 'smwwscout/scoutinvite', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
          //setSuccess(data.data.result);
          localStorage.setItem("invitesuccessMessage", data.data.result);
          window.location.href = "/user/"+uid;
        }
  };

  const validate = (data) => {
  const newErrors = {};

  if(!data.subject.trim()) { 
    alert('Subject is required');
    
    newErrors.subject = 'Subject is required';
   
  }
   else if(!data.details.trim()) { 
    alert('Details is required');
    newErrors.details = 'Details is required';
    
  }

  return newErrors;
  };
  const addtaskvalidate = (data) => {
  const newErrors = {};

  if(!data.subject.trim()) { 
    alert('Event Title is required');
    
    newErrors.subject = 'Event Title is required';
   
  }
  else if(!data.due_date.trim()) { 
    alert('Due Date is required');
    
    newErrors.due_date = 'Due Date is required';
   
  }
  

  return newErrors;
  };
    const handleSubmit = async event => {
       //const formErrors = validate(eventformData);

      //if (Object.keys(formErrors).length == 0) {
        event.preventDefault();
        const postData = eventformData;
        const response = await fetch(app_url + 'smwweventlog/addevent', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            //setShowEventModal(false);
            setActiveModal(null);
            Swal.close();
            setEventList(data.data.result);
           // window.location.reload();
            
        }
      //}
    };
    const handleTaskSubmit = async event => {
      const formErrors = addtaskvalidate(taskformData);

      if (Object.keys(formErrors).length == 0) {
        event.preventDefault();
        const postData = taskformData;
        const response = await fetch(app_url + 'smwwtask/addtask', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            //setShowTaskModal(false);
            setActiveModal(null);
            Swal.close();
            setTaskList(data.data.result);
        }
      }
    };
    const handleTaskComplete = async (value) => {

        // const confirmed = window.confirm('Are you sure you want to mark this task as complete? This cannot be undone.');

        //   if (confirmed) {
           const postData = {
            uid:uid,
            id:value
          };
          try {
            const response = await fetch(app_url + 'smwwtask/completetask', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               
               setTaskList(data.data.result);
            }
          } catch (err) {
            
        }
        // } else {
        //   // User clicked "Cancel"
      
        // }
       
    };
    const handleTaskCompleteWithouConfirm = async (value) => {
        const postData = {
            uid:uid,
            id:value
          };
          try {
            const response = await fetch(app_url + 'smwwtask/completetask', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               
               setTaskList(data.data.result);
            }
          } catch (err) {
            
        }
       
       
    };
    const handleViewTaskSubmit = async (value) => {
       
        const postData = {
          formData: viewtaskformData,
          id: value
          };
        const response = await fetch(app_url + 'smwwtask/updatetask', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            //setShowViewTaskModal(false);
            setActiveModal(null);
            Swal.close();
            setTaskList(data.data.result);
        }
    };
    console.log("Active Modal:", activeModal);

const htmlLabels = ["Salesperson", "Email Address", "Biography","Career Information","Sports Background","Professional Background","Volunteer Work","Mission Statement","Q&A","How to Contact","Video Highlights","Most Recent Seasons Stats"];

const highlightedLabels = ["Tell Us Your Story", "Salesperson", "Email Address", "Primary Phone", "Current Job", "Education Level Completed"]

const specialField = ["Tell Us Your Story"]

const agentScoutStatus = ["Status", "Scout", "Agent Status", "Scout Status" ]

const profilePic = ["Picture"]

const leadTypeList = ["Lead Type", "Lead Sort Flag"]


  async function getDocTalkList() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'doctalk/getdoctalklist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setDocTalks(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }

  const handleButtonClick = async () => {
    const next = !openDOC;
    setOpenDOC(next);
    setSearch("");

    if (next && docTalks.length === 0) {
      getDocTalkList();
    }
  };

  const handleSelect = async (docTalk) => {
    try {
     
      const postData = {
           doctalknid: docTalk.value,
           drupal_uid:uid
          };
          try {
            const response = await fetch(app_url + 'doctalk/addusertodoctalk', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               alert(`${docTalk.label} added successfully`);
               
               setOpenDOC(false);
              setSearch("");
               geteventlist();
               getapplicationdetails();
               //window.location.reload();
              
            }
          } catch (err) {
            
        }
      
      
    } catch (err) {
      console.error(err);
    }
  };

  const filtered = docTalks.filter((item) =>
    item.label?.toLowerCase().includes(search.toLowerCase())
  );

const dropdownRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenDOC(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

    return (
      <>
   {isLoading ? (
        <Loading />
      ) : (
        <>
        {activeView === "view" ? (<>
        <div className="page-view-myorder application-user-profile view-app-user-profile"> 

          <div className='viewtab-top-section' style={{marginTop: "-29px"}}>
            <div>
          {((userLoggedInRoles.includes(configData.ROLE_AGENT) && !agencyDomains.includes(domainName) && loggedin_drupal_uid == uid) &&
          !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) 
          || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && ( 
            <div className='domain-alert'>
              Trying to access your SMWW Agency account? 
              <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/users/"+username} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
            </div>
          )}
          {((userLoggedInRoles.includes(configData.ROLE_SCOUT) && !scoutDomains.includes(domainName) && loggedin_drupal_uid == uid) &&
          !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) 
          || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && ( 
            <div className='domain-alert'>
              Trying to access your SMWW Scout account? 
              <a href={"https://"+configData.RSMWW_SCOUT_DOMAIN+"/users/"+username} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
            </div>
          )}
            {successEditMessage && (
              <div className="set-message-done" style={{marginBottom: "5px"}}>
                <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span>&nbsp;
                {/* {successEditMessage} */}
                <span
                    dangerouslySetInnerHTML={{ __html: successEditMessage }}
                />
              </div>
            )}
          <div className="user-profile-buttons">
          {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
          (userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && 
          !((userLoggedInRoles.includes(configData.ROLE_AGENT) && agencyDomains.includes(domainName)) || 
          (userLoggedInRoles.includes(configData.ROLE_SCOUT) && scoutDomains.includes(domainName))))) && (
          <>
          
            <div className="actions-row-1">
            {userRoles.includes(configData.ROLE_APPLICATION) && 
            <>
            {loggedin_drupal_uid != uid && (
            <><a href style={{cursor:'pointer',color:"#2a7ab5",textDecoration:"underline",fontSize:"13px"}} class="masquerade-switch" onClick={() => handleImpersonate(uid)}>Impersonate this user</a></>
            )}
            <input type="button" name="send_agent_invite" id="send_agent_invite" value="Send Agent Invite" onClick={() => handleAgentInvite()}/>
          <input type="button" name="send_scout_invite" id="send_scout_invite" value="Send Scout Invite" onClick={() => handleScoutInvite()}/></>}

<div className='doc-talk-block-dropdown'>
            <Box ref={dropdownRef} sx={{ position: "relative", display: ["-webkit-inline-flex", "inline-flex"] }}>
              {/* BUTTON */}
              <Button 
                variant="contained" 
                onClick={handleButtonClick}
                sx={{
                  backgroundColor: "#fff",
                  border: "1px solid #bbb",
                  borderRadius: "2px",
                  color: "#111",
                  fontSize: "12px",
                  fontWeight: "400",
                  marginRight: "9px",
                  marginTop: "5px",
                  padding: "5px 8px",
                  boxShadow: "none",
                  lineHeight: "1.2",
                  textTransform: "none",
                  fontFamily: "inherit",
                  "&:hover": {
                    backgroundColor: "#ccc",
                  },
                }}
              >
                Add to DOC Talk
              </Button>

              {/* DROPDOWN */}
              {openDOC && (
                <Box
                  className="doc-talk-dropdown"
                  sx={{
                    position: "absolute",
                    top: 40,
                    width: 300,
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    background: "#fff",
                    zIndex: 999,
                    boxShadow: 3,
                  }}
                >
                  {/* SEARCH INSIDE DROPDOWN */}
                  <Box sx={{ p: 1 }}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Search Doc Talk..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Box>

                  {/* OPTIONS */}
                  <Box sx={{ maxHeight: 250, overflowY: "auto" }}>
                    {filtered.length > 0 ? (
                      filtered.map((item) => (
                        <Box
                          key={item.value}
                          onClick={() => handleSelect(item)}
                          sx={{
                            p: 1,
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                        >
                          {item.label}
                        </Box>
                      ))
                    ) : (
                      <Box sx={{ p: 1, color: "gray" }}>No results found</Box>
                    )}
                  </Box>
                </Box>
              )}
            </Box>  

          {userRoles.includes(configData.ROLE_APPLICATION) && 
            <>
          <a href={'/add_to_earena/'+uid} target="_blank"><input type="button" name="add_to_earena" id="add_to_earena" value="Add to E-Arena"/></a></>}
</div>

          </div>

          </>
          
          )}
          {/* <input type="button" name="add_sortflag" id="add_sortflag" value="Add SortFlag" onClick={() => handleOpenSortflagModal()}/> */}
          {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
            userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) || loggedin_drupal_uid == uid) && (
             <div className="actions-row-2"><button class="main-app-action-btn edit-fields-btn" onClick={showView}>✎ Edit</button></div>)}
         
           
          </div>
          {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
            <>
          {!(
            (
              userLoggedInRoles.includes(configData.ROLE_AGENT) &&
              !((userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && loggedin_drupal_uid != uid) || 
              userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
              userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
              agencyDomains.includes(domainName)
            ) ||
            (
              userLoggedInRoles.includes(configData.ROLE_SCOUT) &&
              !((userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && loggedin_drupal_uid != uid) || 
              userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
              userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
              scoutDomains.includes(domainName)
            )
          ) && (
          <div style={{padding: "10px 18px"}}>
          {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
          userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) || userRoles.includes(configData.ROLE_MENTOR) || (loggedin_drupal_uid == uid)) && (
          <div><div class="user-image" style={{ marginRight: '2%'}}>
          {applicationPicture ? (  
            <><img  src={applicationPicture} width="100px" height="100px" alt = "user"/></>
          ):(
            <><img  src={domain_url+"pictures/notavailable.jpg"} width="100px" height="100px" alt = "user"/></>
          )}
           </div>
           
          <div class="user-name-loc" style={{marginBottom:'2%'}}>
            <span class="user-name" style={{color:"#333333"}} >{appUserDetail.first_name} {appUserDetail.last_name}</span>
            <span class="user-loc" style={{marginBottom:"5px",fontSize:"13px",color:"#666666"}}>{appUserDetail.city && appUserDetail.city+', '} 
              {appUserDetail.state && appUserDetail.state+', '} {appUserDetail.country && appUserDetail.country}</span>
              {!userRoles.includes(configData.ROLE_MENTOR) && (
                <span style={{ backgroundColor: '#FFFF00', padding: '2px 8px', color: '#333333',fontSize:"13px",width:"167px" }}><strong>Recent app: {applicationRecentApp}</strong></span>
              )}
            {((appRegStep || applicationStatus) && (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && 
            <div className='user-profile-status-badges-row'>
              {applicationStatus && <span className='user-profile-status-badge badge-green'>{applicationStatus}</span>}
              {appRegStep && <span className='user-profile-status-badge badge-teal'>Step {appRegStep}</span>}
            </div>}
          </div>
          <div className='user-media-clear-both'></div>
          </div>
           )}
           {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) || (loggedin_drupal_uid == uid)) && (
          <div className='profile-right'>
          <div class="user_total_amount profile-right-components" style={{ float: 'right', fontWeight: 'bold' }}>
            <span class="total-label total-media-label" style={{fontSize:"13px"}}>Total Purchased:</span><br/>
            <span class="total-value app-prof-total-value" style={{fontSize:"20px"}} >${appProfTotal}</span>
          </div> 
           {(userRoles.includes(configData.ROLE_APPLICATION) && (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) &&(
            <div className='profile-right-components'><div className="app-id-label">App ID</div><div className="app-id-val">{applicationID}</div></div>
          )}
          
            {(appSalespersonLink && (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) &&
            <div className='profile-right-components'>
              <span className='profile-right-component-span app-id-label'>Salesperson: </span>
              <span className='profile-right-component-span'><span dangerouslySetInnerHTML={{ __html: appSalespersonLink }} /></span>
            </div>}
          </div>
           )}
           </div>
          )}
          </>) : (<></>)}
              <div style={{clear: "both"}}></div>
              </div>
              </div>

        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && (
          <>

            <div class={`view-user-profile-section-header ${toggles["appliedCourses"] ? "open" : ""}`}>
              <div class="app-aspect-content" onClick={() => handleToggle("appliedCourses")}>
                <div class="aspect-info">
                  <span class="view-user-profile-section-heading">
                    {/* <b>Applied to the following Course(s):</b> */}
                    <b>Applied Course(s)</b>
                  </span>
                </div>
              </div>
              {toggles.appliedCourses && ( 
              <div class="view-user-profile-section-body-container">
                <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                  <div class="opinion-header profile_summary view-user-profile-section-content">
                    <div className='profile-course-add-bar'>
                        <Autocomplete
                          size="small"
                          options={Array.isArray(coursesList) ? coursesList : []}
                          getOptionLabel={(option) =>
                            `${option.courses_special_code} - ${option.course_name}`
                          }
                          value={selectedCourse}
                          onChange={(event, value) => setSelectedCourse(value)}
                          inputValue={inputCourseValue}
                          onInputChange={(event, newInputValue) => {
                            setInputCourseValue(newInputValue);
                          }}
                          className='profile-course-search'
                          PopperComponent={CustomPopper}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search courses"
                              size="small"
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: 28,
                                  fontSize: "13px",
                                },
                                "& .MuiInputBase-input": {
                                  padding: "2px 8px",
                                },
                              }}
                            />
                          )}
                        />

                        <button
                          onClick={() => {
                            if (!selectedCourse) return;

                            handleAddCourse(selectedCourse.course_code);

                            setSelectedCourse(null);
                            setInputCourseValue(""); 
                          }}
                          disabled={!selectedCourse}
                          className="profile-course-add-btn"
                        >
                          + Add
                        </button>
                      </div>
                      {appliedcoursesList.length > 0 && (
                        <span className='profile-applied-course-tag-row'>
                          {appliedcoursesList.map((item, index) => {
                            return <>
                              <span className='profile-applied-course-tags'>{item['name']} <a href className='profile-applied-course-tag-remove' onClick={() => handleDeleteCourse(item['code'])}>✕</a></span>
                            </>
                          })}  
                        </span>
                      )}
            
                  </div>
                </div>
              </div>)}
            </div>

        <div className={`view-user-profile-section-header ${toggles["keyAppInfo"] ? "open" : ""}`}>
            <div class="app-aspect-content" onClick={() => handleToggle("keyAppInfo")}>
                <div class="aspect-info">
                    <span class="view-user-profile-section-heading"><strong>Key Applicant Info</strong></span>
                </div>
            </div>
            {toggles.keyAppInfo && ( 
            <div class="view-user-profile-section-body-container">
                <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                    <div class="opinion-header profile_summary view-user-profile-section-content">
                        <table className='user-profile-summary-table'>
                            <tbody>
                                {keyinfo && (
                                  keyinfo.map((item, index) => (
                                    <>
                                    {specialField.includes(item.label) ? (
                                      <tr className="tell-us-story-row">
                                        <td colSpan="2">
                                          <div className="tell-us-story-content">
                                            {highlightedLabels.includes(item.label) ? (
                                              <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                            ) : (
                                              <span class="user-profile-label">{item.label}:&nbsp;</span>
                                            )}
                                            <span className="user-profile-value">{item.value}</span>
                                          </div>
                                        </td>
                                      </tr>
                                    ) : (
                                    <tr>
                                        <td className='user-profile-summary-row' valign="top">
                                          {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                          {highlightedLabels.includes(item.label) ? (
                                            <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                          ) : (
                                            <span class="user-profile-label">{item.label}:&nbsp;</span>
                                          )}
                                        </td>
                                        <td className='user-profile-summary-row' valign="top">
                                        {/* {item.value || '-'} */}
                                            {htmlLabels.includes(item.label) ? (
                                                <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                            ) : (
                                                <span className='user-profile-value'>{item.value || "-"}</span>
                                            )}
                                        </td>
                                    </tr>)}
                                  </>
                                )))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>)}
        </div>

        <table id="event_logs_js" className="EventLog white view-profile-tables"  border="0" cellpadding="2"  cellspacing="0">
          <colgroup>
          <col style={{width: "5%"}}></col>
          <col style={{width: "15%"}}></col>
          <col style={{width: "20%"}}></col>
          <col style={{width: "25%"}}></col>
          <col style={{width: "35%"}}></col>
          </colgroup>
          <tbody>
            <tr style={{height: "32px", verticalAlign: "middle"}} className=''>
                <td height="17" colspan="4" align="left" class="infobar">
                  <span className='view-user-toggle-header-title' style={{marginLeft: "8px"}}>&nbsp;<b>Event Log</b> 20 Most Recent</span>&nbsp;&nbsp;<a href={"/eventlog/more/"+uid} target="_blank" style={{'color':'#2C99D2'}}>More</a></td>
                <td align="right" class="infobar outbound_image" style={{paddingRight: "16px"}}>
                    <a href onClick={() => handleModalOpen('add_event_log')} style={{'cursor':'pointer', paddingRight: "10px"}} title="Event Log" class="thickbox"><img src="/basic/web/images/outboundcall.gif" alt="Out Bound Call" title="Out Bound Call" border="0" align="top"/></a>
                {/* </td>
                <td style={{backgroundColor: "#091C59", textAlign: "right", paddingRight: "30px"}}> */}
                  <span onClick={() => handleToggle("eventLog")} style={{ cursor:"pointer"}}>
                    {/* <span 
                      style={{ 
                        width: '24px', 
                        height: '24px', 
                        display: 'inline-block',
                        backgroundImage: `url(${SVG_UP})`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        // The rotation logic:
                        transform: toggles.eventLog ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease', // Makes the arrow flip smoothly
                      }} 
                    /> */}
                    <span className={`user-profile-rotate-arrow ${toggles.eventLog ? "open" : ""}`}>▼</span>

                  </span>
                </td>
            </tr>
           
            {toggles.eventLog && ( <>  
               <tr style={{'background-color':'#CCCCCC' }} valign="top">
                <td>&nbsp;</td><td><b>Date</b></td><td><b>Who</b></td><td><b>Subject</b></td><td><b>Details</b></td>
            </tr>
             {eventlist.length > 0 ? (
            <>
            {eventlist.map((item, index) => {
                return <>
               <tr valign="top">
                <td><img src="/basic/web/images/viewlog.gif" style={{'cursor':'pointer'}} onClick={() => handleViewModalOpen('view_event_log',item['event_id'])}/></td><td>{item['date']}</td><td>{item['who']}</td><td>{item['subject']}</td><td dangerouslySetInnerHTML={{ __html: item['details'] }}></td>
            </tr>
                </>
                    
            })}  
            </>
            ) : (
                <><tr id="no_events"><td colspan="5"><b>There are no events associated to this record</b></td></tr></>
            )}
            </>)}
          </tbody>
        </table>
        
                <div className='task_result_wrapper'>
                <table id="task_result" width="382" border="0" cellpadding="0" class="white" cellspacing="0" className='view-profile-tables'>
                  <colgroup>
                    <col style={{width: "5%"}}></col>
                    <col style={{width: "10%"}}></col>
                    <col style={{width: "10%"}}></col>
                    <col style={{width: "10%"}}></col>
                    <col style={{width: "10%"}}></col>
                    <col style={{width: "15%"}}></col>
                    <col style={{width: "20%"}}></col>
                    <col style={{width: "19%"}}></col>
                    <col style={{width: "1%"}}></col>
                  </colgroup>
                  <tbody><tr style={{height: "32px", verticalAlign: "middle"}}>
                    <td height="17" colspan="7" align="left" class="infobar">
                      <span className='view-user-toggle-header-title' style={{marginLeft: "7px"}}>&nbsp;<b>Scheduled Tasks</b>10 Most Recent</span>&nbsp;&nbsp;<a href={"/moretasks/"+uid} style={{'color':'#2C99D2'}}  target="_blank">More</a>
                    </td>
                    <td align="right" class="infobar desktop_add_task">
                      <a href style={{'cursor':'pointer'}} onClick={() => handleModalOpen('add_task')} title="Add Task" class="thickbox">
                      <img src="/basic/web/images/newTask.gif" alt="Create New Task" border="0" /></a>&nbsp;
                    </td>
                    <td style={{backgroundColor: "#091C59", textAlign: "right", paddingRight: "16px"}}>
                      <span onClick={() => handleToggle("scheduleTask")} style={{ cursor:"pointer"}}>
                        {/* <span 
                          style={{ 
                            width: '24px', 
                            height: '24px', 
                            display: 'inline-block',
                            backgroundImage: `url(${SVG_UP})`,
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            // The rotation logic:
                            transform: toggles.scheduleTask ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease', // Makes the arrow flip smoothly
                          }} 
                        /> */}
                        <span className={`user-profile-rotate-arrow ${toggles.scheduleTask ? "open" : ""}`}>▼</span>

                      </span>
                    </td>
                  </tr>
                  {toggles.scheduleTask && ( <> 
                  <tr bgcolor="CCCCCC">
                    <td width="30">&nbsp;</td>
                    <td width="70"><b>Created</b></td>
                    <td><b>Sales Person</b></td>
                    <td width="70"><b>Due Date</b></td>
                    <td width="60"><b>Priority</b></td>
                    <td><b>Who</b></td>
                    <td><b>Acct</b></td>
                   
                    <td width=""><b>Subject</b></td>
                    
                    <td width="30">&nbsp;</td>
                  </tr>
                  
                  {tasklist.length > 0 ? (
                    <>
                      {tasklist.map((item, index) => {

                        const isPast = isPastDateTimeInPST(item['field_due_date']);
                       
                        return <>
                          <tr bgcolor={item['bg_color']}>
                             {isPast ? (
                              <td><a href style={{'cursor':'pointer'}} onClick={() => handleTaskCompleteWithouConfirm(item['id'])} title="Mark Complate"><img src="/basic/web/images/markascomplete.gif" alt="Mark as Complete" border="0" /></a></td>
                             ):(

                               <td><a href style={{'cursor':'pointer'}} onClick={() => handleTaskComplete(item['id'])} title="Mark Complate"><img src="/basic/web/images/markascomplete.gif" alt="Mark as Complete" border="0" /></a></td>
                             )
                            }
                            <td>{item['created']}</td>
                            <td><a style={{'cursor':'pointer'}} href={"/user/"+item['field_assignee_uid']}>{item['field_assignee']}</a></td>
                            <td>{item['field_due_date']}</td>
                            <td>{item['field_priority']}</td>
                            <td>{item['who']}</td>
                            <td><a href style={{'cursor':'pointer'}} onClick={() => handleModalOpen('add_event_log')} title="Event Log" class="thickbox"><img src="/basic/web/images/outboundcall.gif" alt="Out Bound Call" title="Out Bound Call" border="0" align="top" /></a>
                                {userLoggedInRoles.includes(configData.ROLE_AGENT) && userRoles.includes(configData.ROLE_ATHLETE) ? (
                                <a style={{'cursor':'pointer'}} href={"/view_athlete/"+uid}><img src="/basic/web/images/ViewOwnerProfile.gif" alt="View Profile" border="0" align="top" />&nbsp;{item['owner']}</a>
                                ): (
                                  <a style={{'cursor':'pointer'}} href={"/user/"+uid}><img src="/basic/web/images/ViewOwnerProfile.gif" alt="View Profile" border="0" align="top" />&nbsp;{item['owner']}</a>
                                )}
                                </td>
                            <td><a href onClick={() => handleViewModalOpen('view_task',item['id'])} title="View Task" class="thickbox"><img src="/basic/web/images/viewtaskdetails.gif" alt="View Task Details" border="0" align="top" />{item['title']}</a></td>
                            <td align="right" width="25">&nbsp;</td>
                            
                          </tr>
                        </>
                    
                      })}  
                    </>
                  ) : (
                      <><tr id="no_events"><td colspan="10"><b>There are no pending items in your task schedule</b></td></tr></>
                  )}
                  </>)}                              
                        </tbody></table></div>


            <div class={`view-user-profile-section-header ${toggles["profileSummary"] ? "open" : ""}`}>
              <div class="app-aspect-content" onClick={() => handleToggle("profileSummary")}>
                <div class="aspect-info">
                  <span class="view-user-profile-section-heading"><strong>Profile Summary</strong></span> 
                </div>
              </div>
              {toggles.profileSummary && ( 
              <div class="view-user-profile-section-body-container">
              <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                
                <div class="opinion-header profile_summary view-user-profile-section-content">
                  <table className='user-profile-summary-table'>
                    <tbody>
                        {profilesummary && (
                        profilesummary.map((item, index) => (
                        <tr>
                            <td className='user-profile-summary-row' valign="top">
                              {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}

                              {highlightedLabels.includes(item.label) ? (
                                  <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                              ) : (
                                  <span class="user-profile-label">{item.label}:&nbsp;</span>
                              )}

                            </td>
                            {/* <td className='user-profile-summary-row' valign="top">{item.value || '-'}</td> */}
                            <td className='user-profile-summary-row' valign="top">
                            {/* {item.value || '-'} */}
                                {/* {htmlLabels.includes(item.label) ? (
                                    <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                ) : (
                                    <span className='user-profile-value'>{item.value || "-"}</span>
                                )} */}
                                {
                                  htmlLabels.includes(item.label) ? (
                                    <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                  ) : agentScoutStatus.includes(item.label) ? (
                                    <span className='user-profile-value agent-scout-status-color'>{item.value || "-"}</span>
                                  ) : (
                                    <span className='user-profile-value'>{item.value || "-"}</span>
                                  )
                                }
                            </td>
                        </tr>
                        )))}
                    
                    </tbody>
                  </table>
                </div>	
              </div>
            </div>)}
          </div>

  </>
  )}
    <div>

      {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && (
        <>
        <div class={`view-user-profile-section-header ${toggles["sameAppToggle"] ? "open" : ""}`}>
        <div class="app-aspect-content" onClick={() => handleToggle("sameAppToggle")}>
            <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Same App</strong></span> 
            </div>
        </div>
        {toggles.sameAppToggle && ( 
            <div class="view-user-profile-section-body-container">
            <div class="profile_summary_sentiment-wrapper view-user-profile-section-body">
            
                    <div class="opinion-header profile_summary view-user-profile-section-content">
                <table className='user-profile-sameapp-table'><tbody><tr><td style={{width: "30%"}}>
                Same App:</td><td>
                <Autocomplete
                    id="user_search"
                    size="small"
                    PopperProps={{
                    disablePortal: false, // Ensure this is false (default) to use a portal
                    }}
                    options={options}  
                    PopperComponent={CustomPopper}
                    renderOption={renderOption}
                    getOptionLabel={getOptionLabel}
                    inputValue={inputValue}
                    onInputChange={handleInputChange}
                    onChange={handleSameAppChange}
                    loading={loading} // Material UI Autocomplete has a built-in loading prop
                    className='profile-course-search'
                    renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search"
                        InputLabelProps={{
                        sx: {
                            fontSize: "12px",
                            top: "-2px", 
                            "&.MuiInputLabel-shrink": {
                            top: 0,
                            fontSize: "12px",  
                            },
                        },
                        }}
                        InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                            </>
                        ),
                        }}
                        size="small"
                        sx={{
                        "& .MuiInputBase-root": {
                            height: 28,
                            fontSize: "13px",
                        },
                        "& .MuiInputBase-input": {
                            padding: "2px 8px",
                        },
                        }}
                    />
                    )}
                /> 
                </td></tr></tbody></table>
                {sameapplist.length > 0 && (
                    <span className='profile-applied-course-tag-row' style={{padding: "10px 0px"}}>
                    {sameapplist.map((item, index) => {
                        return <>
                        <span className='profile-applied-course-tags'><a target="_blank" href={"/user/"+item['drupal_uid']}>{item['name']}</a> <a href className='profile-applied-course-tag-remove' onClick={() => handleDeleteSameApp(item['id'],item['match_uid'],uid)}>✕</a></span>
                        </>
                    })}  
                    </span>
                )}
            </div>	
            </div>
        </div>)}
        </div>
<div className={`view-user-profile-section-header ${toggles["AppSysData"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("AppSysData")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Application & System Data</strong></span>
        </div>
    </div>
    {toggles.AppSysData && (
        <div class="view-user-profile-section-body-container">
            <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                <div class="opinion-header profile_summary view-user-profile-section-content">
                    <table className='user-profile-summary-table'>
                        <tbody>
                            {systeminfo && (
                                systeminfo.map((item, index) => (
                                <tr>
                                <td className='user-profile-summary-row' valign="top">
                                  {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                  {highlightedLabels.includes(item.label) ? (
                                    <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                  ) : (
                                    <span class="user-profile-label">{item.label}:&nbsp;</span>
                                  )}
                                </td>
                                <td className='user-profile-summary-row' valign="top">
                                {/* {item.value || '-'} */}
                                    {htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                    )}
                                </td>
                                </tr>
                            )))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )}
</div>
      </>)}

      {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || userLoggedInRoles.includes(configData.ROLE_AGENT) || userLoggedInRoles.includes(configData.ROLE_SCOUT)) && (
      <>
        <div className={`view-user-profile-section-header ${toggles["contactInfo"] ? "open" : ""}`}>
          <div class="app-aspect-content" onClick={() => handleToggle("contactInfo")}>
            <div class="aspect-info">
              <span class="view-user-profile-section-heading"><strong>Contact & Address</strong></span>
            </div>
          </div>
          {toggles.contactInfo && ( 
            <div class="view-user-profile-section-body-container">
            <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                
            <div class="opinion-header profile_summary view-user-profile-section-content">
                <table className='user-profile-summary-table'>
                    <tbody>
                    {contactinfo && (
                        contactinfo.map((item, index) => (
                        <tr>
                            <td className='user-profile-summary-row' valign="top">
                              {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                              {highlightedLabels.includes(item.label) ? (
                                <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                              ) : (
                                <span class="user-profile-label">{item.label}:&nbsp;</span>
                              )}
                            </td>
                            <td className='user-profile-summary-row' valign="top">
                            {/* {item.value || '-'} */}
                                {htmlLabels.includes(item.label) ? (
                                    <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                ) : (
                                    <span className='user-profile-value'>{item.value || "-"}</span>
                                )}
                            </td>
                        </tr>
                    )))}
                    
                    </tbody>
                </table>
            </div>
            </div>
          </div>)}
        </div>
      </>)}

      {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && (
        <>
<div className={`view-user-profile-section-header ${toggles["educationToggle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("educationToggle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Education</strong></span>
        </div>
    </div>
    {toggles.educationToggle && (
        <div class="view-user-profile-section-body-container">
            <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                <div class="opinion-header profile_summary view-user-profile-section-content">
                    <table className='user-profile-summary-table'>
                        <tbody>
                            {educationinfo && (
                                educationinfo.map((item, index) => (
                                <tr>
                                <td className='user-profile-summary-row' valign="top">
                                  {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                  {highlightedLabels.includes(item.label) ? (
                                    <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                  ) : (
                                    <span class="user-profile-label">{item.label}:&nbsp;</span>
                                  )}
                                </td>
                                {/* <td className='user-profile-summary-row' valign="top">{item.value || '-'}</td> */}
                                <td className='user-profile-summary-row' valign="top">
                                {/* {item.value || '-'} */}
                                    {htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                    )}
                                </td>
                                </tr>
                            )))}
                        
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )}
</div>

<div className={`view-user-profile-section-header ${toggles["socialMediaToggle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("socialMediaToggle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Socials & Links</strong></span>
        </div>
    </div>
    {toggles.socialMediaToggle && (
        <div class="view-user-profile-section-body-container">
            <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                <div class="opinion-header profile_summary view-user-profile-section-content">
                    <table className='user-profile-summary-table'>
                        <tbody>
                            {socialinfo && (
                                socialinfo.map((item, index) => (
                                <tr>
                                <td className='user-profile-summary-row' valign="top">
                                  {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                  {highlightedLabels.includes(item.label) ? (
                                    <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                  ) : (
                                    <span class="user-profile-label">{item.label}:&nbsp;</span>
                                  )}
                                </td>
                                {/* <td className='user-profile-summary-row' valign="top">{item.value || '-'}</td> */}
                                <td className='user-profile-summary-row' valign="top">
                                {/* {item.value || '-'} */}
                                    {htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                    )}
                                </td>
                                </tr>
                            )))}
                        
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )}
</div>

<div className={`view-user-profile-section-header ${toggles["careerToggle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("careerToggle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Background & Career</strong></span>
        </div>
    </div>
    {toggles.careerToggle && (
        <div class="view-user-profile-section-body-container">
            <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                <div class="opinion-header profile_summary view-user-profile-section-content">
                    <table className='user-profile-summary-table'>
                        <tbody>
                            {careerinfo && (
                                careerinfo.map((item, index) => (
                                <tr>
                                <td className='user-profile-summary-row' valign="top">
                                  {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                  {highlightedLabels.includes(item.label) ? (
                                    <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                  ) : (
                                    <span class="user-profile-label">{item.label}:&nbsp;</span>
                                  )}
                                </td>
                                {/* <td className='user-profile-summary-row' valign="top">{item.value || '-'}</td> */}
                                <td className='user-profile-summary-row' valign="top">
                                {/* {item.value || '-'} */}
                                    {htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                    )}
                                </td>
                                </tr>
                            )))}
                        
                        
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )}
</div>

<div className={`view-user-profile-section-header ${toggles["accountAdminToggle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("accountAdminToggle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Account & Admin</strong></span>
        </div>
    </div>
    {toggles.accountAdminToggle && (
        <div class="view-user-profile-section-body-container">
            <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                <div class="opinion-header profile_summary view-user-profile-section-content">
                    <table className='user-profile-summary-table'>
                        <tbody>
                            {userinfo && (
                                userinfo.map((item, index) => (
                                <tr>
                                <td className='user-profile-summary-row' valign="top">
                                  {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                  {highlightedLabels.includes(item.label) ? (
                                    <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                  ) : (
                                    <span class="user-profile-label">{item.label}:&nbsp;</span>
                                  )}
                                </td>
                                {/* <td className='user-profile-summary-row' valign="top">{item.value || '-'}</td> */}
                                <td className='user-profile-summary-row' valign="top">
                                {/* {item.value || '-'} */}
                                    {/* {htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                    )} */}

                                  {
                                    htmlLabels.includes(item.label) ? (
                                      <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : profilePic.includes(item.label) ? (
                                      <span className='user-profile-value'>
                                        <img
                                          src={item.value || domain_url+"pictures/notavailable.jpg"}
                                          alt='user'
                                          style={{maxHeight: "100px", maxWidth: "100px"}}
                                        />
                                      </span>
                                    ) : (
                                      <span className='user-profile-value'>{item.value || "-"}</span>
                                    )
                                  }
                                </td>
                                </tr>
                            )))}
                        
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )}
</div>

<div className={`view-user-profile-section-header ${toggles["miscellaneousToggle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("miscellaneousToggle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Miscellaneous</strong></span>
        </div>
    </div>
    {toggles.miscellaneousToggle && (
        <div class="view-user-profile-section-body-container">
            <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                <div class="opinion-header profile_summary view-user-profile-section-content">
                    <table className='user-profile-summary-table'>
                        <tbody>
                            {appMiscInfo && (
                                appMiscInfo.map((item, index) => (
                                <tr>
                                <td className='user-profile-summary-row' valign="top">
                                  {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                  {highlightedLabels.includes(item.label) ? (
                                    <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                  ) : (
                                    <span class="user-profile-label">{item.label}:&nbsp;</span>
                                  )}
                                </td>
                                {/* <td className='user-profile-summary-row' valign="top">{item.value || '-'}</td> */}
                                <td className='user-profile-summary-row' valign="top">
                                {/* {item.value || '-'} */}
                                    {htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                    )}
                                </td>
                                </tr>
                            )))}

                            {userLeadAsset && (
                                userLeadAsset.map((item, index) => (
                                <tr>
                                <td className='user-profile-summary-row' valign="top">
                                  {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                  {highlightedLabels.includes(item.label) ? (
                                    <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                  ) : (
                                    <span class="user-profile-label">{item.label}:&nbsp;</span>
                                  )}
                                </td>
                                {/* <td className='user-profile-summary-row' valign="top">{item.value || '-'}</td> */}
                                <td className='user-profile-summary-row' valign="top">
                                {/* {item.value || '-'} */}
                                    {/* {htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                    )} */}
                                    {
                                      htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                      ) : leadTypeList.includes(item.label) ? (
                                        <span className='user-profile-value'>
                                          <span className='user-profile-value'>{item.full_value || "-"}</span>
                                        </span>
                                      ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                      )
                                    }

                                </td>
                                </tr>
                            )))}

                            {userEventAsset && (
                                userEventAsset.map((item, index) => (
                                <tr>
                                <td className='user-profile-summary-row' valign="top">
                                  {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                  {highlightedLabels.includes(item.label) ? (
                                    <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                  ) : (
                                    <span class="user-profile-label">{item.label}:&nbsp;</span>
                                  )}
                                </td>
                                {/* <td className='user-profile-summary-row' valign="top">{item.value || '-'}</td> */}
                                <td className='user-profile-summary-row' valign="top">
                                {/* {item.value || '-'} */}
                                    {htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                    )}
                                </td>
                                </tr>
                            )))}
                        

                            {userDocTalkAsset && (
                                userDocTalkAsset.map((item, index) => (
                                <tr>
                                <td className='user-profile-summary-row' valign="top">
                                  {/* <span class="user-profile-label">{item.label}:&nbsp;</span> */}
                                  {highlightedLabels.includes(item.label) ? (
                                    <span class="user-profile-label label-highlight">{item.label}:&nbsp;</span>
                                  ) : (
                                    <span class="user-profile-label">{item.label}:&nbsp;</span>
                                  )}
                                </td>
                                {/* <td className='user-profile-summary-row' valign="top">{item.value || '-'}</td> */}
                                <td className='user-profile-summary-row' valign="top">
                                {/* {item.value || '-'} */}
                                    {htmlLabels.includes(item.label) ? (
                                        <span dangerouslySetInnerHTML={{ __html: item.value }} className='user-profile-value' />
                                    ) : (
                                        <span className='user-profile-value'>{item.value || "-"}</span>
                                    )}
                                </td>
                                </tr>
                            )))}
                        
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )}
</div>

            <div class={`view-user-profile-section-header ${toggles["sortFlags"] ? "open" : ""}`}>
              <div class="app-aspect-content" onClick={() => handleToggle("sortFlags")}>
                <div class="aspect-info">
                  <span class="view-user-profile-section-heading">
                    <b>Sort Flags</b>
                  </span>
                </div>
              </div>
              {toggles.sortFlags && ( 
              <div className="view-user-profile-section-body-container">
                <div class="profile_summary_sentiment-wrapper view-user-profile-section-container">
                  <div class="opinion-header profile_summary view-user-profile-section-content">
                    <div className='profile-course-add-bar'>
                      <Select 
                        
                        id="sortflag" name="sortflag" 
                        searchable={true}
                        required={true}  
                        clearable={true} 
                        clearOnBlur={true} 
                        clearOnSelect={true}
                        backspaceDelete={true} 
                        isOpen={true}     
                        className='user-profile-sortflag-select'           
                        options={sortflagList} 
                        onChange={(val) => {
                          if(val.length == 0) {
                            console.log(val);
                          }
                          else{
                            setSortflagValue(val[0]['value']);
                          }}
                        }
                        onDropdownOpen={handleOpen}
                      />
                      <button type="submit" className="profile-course-add-btn" 
                        onClick={handleSortflagSubmit} 
                        disabled={!sortflagValue}
                        // onClick={() => {
                        //   if (!sortflagValue) return;

                        //   handleSortflagSubmit();

                        //   setSortflagValue(""); 
                        // }}
                        // disabled={!sortflagValue}
                      >+ Add</button>
                      </div>
                    {userSortflags.length > 0 && (
                      <span className='profile-applied-course-tag-row'>
                        {userSortflags.map((item, index) => {
                          return <>
                            <span className='profile-applied-course-tags'><a target="_blank" href={"/sort-flag-users/"+item['tid']}>{item['name']} </a><a href  onClick={() => handleDeleteSortflag(item['tid'])}>✕</a>
                              {/* <a href className='profile-applied-course-tag-remove' onClick={() => handleDeleteCourse(item['code'])}>✕</a> */}
                            </span>
                          </>
                        })}  
                      </span>
                    )}
            
                  </div>
                </div>
              </div>)}
            </div>


        </>)}
    </div>


     <div className='add_event_log_container'>
    {activeModal === 'add_event_log' && (
             <SweetAlert
 key="add_event_log"
  show={true}
  title="Add Event Log"
  showConfirmButton={false}
  showCloseButton={true}
  heightAuto={false}
  didClose={handleModalClose}		
  onCancel={handleModalClose}
  customClass={{
    title: 'viewuserprofile-title-modal-header',
    closeButton: 'viewuserprofile-closebutton-modal-header'
  }} 
  > 
 
      <form id="athlete_eventlog" method="post">
       
      <table className='modal-table'> 
        <tbody> <tr>
  <td>Entering event for:</td><td> <strong>{appUserDetail.first_name+' '+appUserDetail.last_name}</strong></td></tr>
    <tr><td>By User:</td><td> <strong>{userLoggedinDetails.first_name+' '+userLoggedinDetails.last_name}</strong></td></tr>
    <tr><td>Start Time:</td><td>{currentDateTimePST}</td></tr>
<tr>
    <td>Subject:</td>
    <td><input type="text" name="subject" defaultValue="Out Bound Call" onChange={handleChange} maxLength={255}/></td>
</tr>
<tr>
    <td>Details:</td>
    <td><textarea name="details" cols="40" rows="7" onChange={handleChange} ></textarea></td>
</tr>
<tr>
    <td></td>
    <td><input type="button" id="btn" name="btn" value="Save" onClick={handleSubmit}/></td>

</tr>
</tbody>
</table>
</form>
    <div class="modal-footer">
     
    </div>
</SweetAlert>
    )}
  
</div>
    {activeModal === 'view_event_log' && (
             <SweetAlert
   key="view_event_log"
    show={true}
  title="View Event Log"
  showConfirmButton={false}
  showCloseButton={true}
  heightAuto={false}
  didClose={handleModalClose}
  onCancel={handleModalClose}	
  customClass={{
    title: 'viewuserprofile-title-modal-header',
    closeButton: 'viewuserprofile-closebutton-modal-header'
  }} 
  > 
        <table id="view-evenglog">
        <tbody>
        <tr>
            
            <td>EventID: <strong>{eventdetailedview.EventID}</strong></td>
            <td>Entered By: <strong>{eventdetailedview.EnteredBy}</strong>
            
            </td>
        </tr>
  
        <tr>
            <td>Event Date: <strong>{eventdetailedview.EventDate}</strong></td>
        </tr>
        <tr>
            <td>Bound To: <strong>{eventdetailedview.drupal_uid}</strong></td>
        </tr>
        <tr>
            <td>Subject: <strong>{eventdetailedview.Subject}</strong></td>
        </tr>
        <tr>
            <td>Details: <strong dangerouslySetInnerHTML={{ __html: eventdetailedview.Details }}></strong></td>
        </tr>
        </tbody>
        </table>
        </SweetAlert>
    )}
  {activeModal === 'add_task' && (
       <SweetAlert
    key="add_task"
    show={true}
    title="Add Task"
    showConfirmButton={false}
    showCloseButton={true}
    heightAuto={false}
    didClose={handleModalClose}		 
    onCancel={handleModalClose}
    customClass={{
    title: 'viewuserprofile-title-modal-header',
    closeButton: 'viewuserprofile-closebutton-modal-header'
  }} 
    > 
        <form id="task-add" className="sweetalert-task-add" method="post">
          <table id="add-task-table">
            <tbody><tr><td><strong>Sales Person:</strong></td>
              <td>
              <select id="salesperson" name="salesperson" value={taskformData.salesperson} onChange={handleTaskChange}>
                <option value="0"></option>
                {salespersonList.length > 0 && (
                <>
                  {salespersonList.map((item, index) => {
                    return <>
                      {item['uid'] != null && (
                        <><option value={item['uid']}>{item['name']}</option></>
                      )}
                    </>
                    
                  })}  
           
                </>
                )}
              </select>
              </td>
            </tr>
          <tr>
            <td><strong>Due Date:</strong></td>
              <td>
              <DatePicker
                    id="datetime"
                    //selected={taskformData.due_date ? new Date(taskformData.due_date) : null}
                    selected={taskformData.due_date_obj ?? null}
                    onChange={handleDateChange}
                    placeholderText=""
                    dateFormat="MM-dd-yyyy h:mm aa"
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={60}
                    className="form-input"
                  />
              </td>
          </tr>
          <tr>
              <td><strong>Priority:</strong></td>
              <td><select name="priority" value={taskformData.priority} onChange={handleTaskChange}>
                  <option value="High">High</option>
                  <option value="Medium" selected="">Medium</option>
                  <option value="Low">Low</option>
              </select></td>
          </tr>

          <tr>
              <td><strong>Event Title:</strong></td>
              <td><input type="text" name="subject" id="subject" onChange={handleTaskChange}/></td>
          </tr>
          <tr>
              <td ><strong>Details:</strong></td>
              <td><textarea name="details" cols="40" rows="7" onChange={handleTaskChange}></textarea></td>
          </tr>
          <tr>
            <td><strong>Course/Conference:</strong></td>
            <td><textarea name="apply_courses" cols="40" rows="3" onChange={handleTaskChange}></textarea></td>
          </tr>
          <tr>
            <td> </td><td>
              <input type="button" className="task-savebtn" id="btn" name="btn" value="Save" onClick={handleTaskSubmit}/>
            </td>
          </tr>
        </tbody>
        </table>
        </form>
    <div class="modal-footer">
     
    </div>
</SweetAlert>
  )}

      {activeModal === 'view_task' && (
           <SweetAlert
        key="view_task"
    show={true}
    title="View Task"
    showConfirmButton={false}
    showCloseButton={true}
    heightAuto={false}
   didClose={handleModalClose}		 
   onCancel={handleModalClose}
   customClass={{
    title: 'viewuserprofile-title-modal-header',
    closeButton: 'viewuserprofile-closebutton-modal-header'
  }} 
    > 
        <form id="task-add" method="post">
          <table id="add-task-table">
            <tbody>
              <tr><td>Scheduled task bound to:</td><td>{taskdetailedview.field_owner_ac_target_id}</td></tr>
              <tr><td>Created:</td><td>{taskdetailedview.created_at}</td></tr>
              <tr><td>By User:</td><td>{taskdetailedview.uid}</td></tr>
              <tr><td>Sales Person:</td>
              <td>
              <select id="salesperson" name="salesperson" onChange={handleViewTaskChange} value={viewtaskformData.salesperson}>
                <option value="0"></option>
                {salespersonList.length > 0 && (
                <>
                  {salespersonList.map((item, index) => {
                    return <>
                      {item['uid'] != null && (
                        <><option value={item['uid']}>{item['name']}</option></>
                      )}
                    </>
                    
                  })}  
           
                </>
                )}
              </select>
              </td>
            </tr>
          <tr>
            <td><strong>Due Date:</strong></td>
              <td>
              <DatePicker
                    id="datetime"
                    selected={viewtaskformData.due_date ? new Date(viewtaskformData.due_date) : null}
                    onChange={handleViewTaskDateChange}
                    placeholderText=""
                    dateFormat="MM-d-yyyy h:mm aa"
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={60}
                    className="form-input"
                    defaultValue={viewtaskformData.field_due_date}
                  />
              </td>
          </tr>
          <tr>
              <td><strong>Priority:</strong></td>
              <td><select name="priority" value={viewtaskformData.priority} onChange={handleViewTaskChange} >
                  <option value="High">High</option>
                  <option value="Medium" selected="">Medium</option>
                  <option value="Low">Low</option>
              </select></td>
          </tr>

          <tr>
              <td><strong>Event Title:</strong></td>
              <td><input type="text" name="subject" defaultValue={viewtaskformData.subject} id="subject" onChange={handleViewTaskChange}/></td>
          </tr>
          <tr>
              <td ><strong>Details:</strong></td>
              <td><textarea name="details" cols="40" rows="7" defaultValue={viewtaskformData.details} onChange={handleViewTaskChange}></textarea></td>
          </tr>
          <tr>
            <td>Course/Conference:</td>
            <td><textarea name="apply_courses" cols="40" rows="3" defaultValue={viewtaskformData.apply_courses} onChange={handleViewTaskChange}></textarea></td>
          </tr>
          <tr>
            <td> </td><td>
              <input type="button" id="btn" className='schedule-task-editsave' name="btn" value="Save" onClick={()=>handleViewTaskSubmit(taskdetailedview.id)}/>
            </td>
          </tr>
        </tbody>
        </table>
        </form>
    {/* </div> */}
    <div class="modal-footer">
     
    </div>
    </SweetAlert>
      )}
    </div>
    </>) : (
      <>
      {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ? (
      <ApplicantAdminEditProfile uid={uid} username={username} userLoggedInRoles={userLoggedInRoles} picture={appUserDetail.picture} userRoles={userRoles} />
      ) : (
      <ApplicantSAAdminEditProfile uid={uid} username={username} userLoggedInRoles={userLoggedInRoles} picture={appUserDetail.picture} userRoles={userRoles} />
      )}
      </>
      )}
    </>
)}
    </>
        
     )
    
    
    }

export default ViewApplicationProfile